import { useState } from "react";
import { Box, TextField, Button, Grid, Link } from "@mui/material";
import "../Login/Login.css";
import "../../common/Common.css";
import { customButtonStyles } from "../../common/commonStyles";
import { useNavigate } from "react-router-dom";
import "../Login/Login.css";
import logo from "../../assets/logo.svg";
import validators from "../../utils/validations/validators";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import api from "../../services/api";

const Registration = () => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: "",
    password: "",
    org_name: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const handleSnackClose = () => setSnackbarOpen(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (validators[name]) {
      const errorMsg = validators[name](value);
      setValidationErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
    }
  };
  const requiredFields = ["org_name", "name", "email", "phone", "password"];

  const isFormValid =
    Object.values(validationErrors).every((err) => err === "") &&
    requiredFields.every(
      (field) =>
        formData[field] !== "" &&
        formData[field] !== null &&
        formData[field] !== undefined
    );

  const navigate = useNavigate();
  const handleSignUp = async () => {
    const { email, name, phone, password, org_name } = formData;

    // API request payload
    const payload = {
      email: email,
      name: name,
      org_name: org_name,
      phone_number: phone,
      password: password,
    };
    if (!isFormValid) {
      setSnackbarOpen({
        status: true,
        message: "Please fill all fields correctly before submitting.",
        severity: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      setSnackbarOpen({
        status: true,
        message: "Passwords do not match. Please re-enter.",
        severity: "error",
      });
      return;
    }
    try {
      const response = await api.post(
        `app/organisation/`,
        payload
      );
      if (response.status === 201) {
        setFormData({
          email: "",
          name: "",
          phone: "",
          password: "",
          org_name: "",
        });
        navigate("/registration_success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{ width: "100%", maxWidth: 400, mx: "auto" }}
        className="login-box"
      >
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img src={logo} alt="Logo" style={{ height: 30, maxHeight: 30 }} />
        </Box>
        <Box>
          <h3 className="login-text">Hello! let's get started</h3>
          <h5 className="login_subtext">Sign up to continue.</h5>
        </Box>
        <TextField
          required
          fullWidth
          size="small"
          label="Organization Name"
          id="fullWidth"
          margin="normal"
          name="org_name"
          value={formData.org_name}
          onChange={handleInputChange}
          autoComplete="off"
          className="custom-textfield"
          error={!!validationErrors.org_name}
          helperText={validationErrors.org_name}
        />
        <TextField
          required
          fullWidth
          size="small"
          label="User Name"
          id="fullWidth"
          margin="normal"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          autoComplete="off"
          className="custom-textfield"
          error={!!validationErrors.name}
          helperText={validationErrors.name}
        />
        <TextField
          required
          fullWidth
          size="small"
          label="Email Id"
          id="fullWidth"
          margin="normal"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          autoComplete="off"
          className="custom-textfield"
          error={!!validationErrors.email}
          helperText={validationErrors.email}
        />
        <TextField
          required
          fullWidth
          size="small"
          label="Mobile Number"
          id="fullWidth"
          margin="normal"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          autoComplete="off"
          className="custom-textfield"
          error={!!validationErrors.phone}
          helperText={validationErrors.phone}
        />
        <TextField
          size="small"
          id="outlined-password-input"
          label="Password"
          type="password"
          autoComplete="off"
          required
          fullWidth
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          margin="normal"
          className="custom-textfield"
          error={!!validationErrors.password}
          helperText={validationErrors.password}
        />
        <TextField
          size="small"
          id="outlined-password-input"
          label="Confirm Password"
          type="password"
          autoComplete="off"
          required
          fullWidth
          name="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          margin="normal"
          className="custom-textfield"
          error={!!validationErrors.confirmPassword}
          helperText={validationErrors.confirmPassword}
        />
        <Button
          variant="contained"
          fullWidth
          sx={customButtonStyles}
          onClick={handleSignUp}
        >
          {" "}
          Sign Up{" "}
        </Button>
        <Grid container spacing={2}>
          <Grid size={12} className="create_account">
            Already have an account?{" "}
            <Link href="/" underline="none">
              Sign In
            </Link>
          </Grid>
        </Grid>
      </Box>
      <ReusableSnackbar
        open={snackbarOpen.status}
        message={snackbarOpen.message}
        onClose={handleSnackClose}
        severity={snackbarOpen.severity}
      />
    </Box>
  );
};

export default Registration;
